// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PriceParity24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PriceParity24: FC<PriceParity24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M2 21v-2h9V7.825A2.92 2.92 0 0 1 9.175 6H6l3 7c0 .833-.342 1.542-1.025 2.125-.683.583-1.508.875-2.475.875-.967 0-1.792-.292-2.475-.875S2 13.833 2 13l3-7H3V4h6.175a2.91 2.91 0 0 1 1.075-1.438A2.906 2.906 0 0 1 12 2c.65 0 1.233.188 1.75.563A2.91 2.91 0 0 1 14.825 4H21v2h-2l3 7c0 .833-.342 1.542-1.025 2.125-.683.583-1.508.875-2.475.875-.967 0-1.792-.292-2.475-.875S15 13.833 15 13l3-7h-3.175A2.918 2.918 0 0 1 13 7.825V19h9v2H2Zm14.625-8h3.75L18.5 8.65 16.625 13Zm-13 0h3.75L5.5 8.65 3.625 13ZM12 6c.283 0 .52-.096.713-.287A.967.967 0 0 0 13 5a.967.967 0 0 0-.287-.713A.968.968 0 0 0 12 4a.968.968 0 0 0-.713.287A.967.967 0 0 0 11 5c0 .283.096.52.287.713.192.191.43.287.713.287Z" />
        </svg>
    );
};

export default PriceParity24;
